/* KAWAII ART 営業日・最短発送日（候補・本番未反映）
   設定は snippets/ka-business-days.liquid が出力する <script id="ka-business-days-config" type="application/json">。
   休業：水・土・日・祝日・臨時休業。祝日が月火木金にある週は水曜営業（水曜自体が祝日なら休み）。
   締切：13時（メッセージ入れありも同じ）。商品ページは「発送目安：ご注文後1～2営業日（メッセージ入れ希望で1～3）」＋急ぎの注記（9/24）。連休の帯：4日以上の連休のとき、直前営業日17時〜連休最終日の前日（最終日は出さない）。 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.KaBusinessDays = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  var DOW = ['日', '月', '火', '水', '木', '金', '土'];
  var DAY = 86400000;
  function utc(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function ymd(d) { return d.toISOString().slice(0, 10); }
  function parseYmd(s) { var p = s.split('-').map(Number); return utc(p[0], p[1], p[2]); }
  function addDays(d, n) { return new Date(d.getTime() + n * DAY); }
  function mondayOf(d) { var w = d.getUTCDay(); return addDays(d, w === 0 ? -6 : 1 - w); }
  function fmt(d) { return (d.getUTCMonth() + 1) + '/' + d.getUTCDate() + '(' + DOW[d.getUTCDay()] + ')'; }

  function makeCalendar(cfg) {
    var hol = {}, closed = {}, open = {};
    (cfg.holidays || []).forEach(function (s) { hol[s] = 1; });
    (cfg.closures || []).forEach(function (s) { closed[s] = 1; });
    (cfg.openDays || []).forEach(function (s) { open[s] = 1; });
    function isHoliday(d) { return !!hol[ymd(d)]; }
    function wedOpen(d) { var mon = mondayOf(d); return [0, 1, 3, 4].some(function (i) { return isHoliday(addDays(mon, i)); }); }
    function isBusinessDay(d) {
      var k = ymd(d);
      if (open[k]) return true;
      if (closed[k] || hol[k]) return false;
      var w = d.getUTCDay();
      if (w === 0 || w === 6) return false;
      if (w === 3) return wedOpen(d);
      return true;
    }
    return { isBusinessDay: isBusinessDay, isHoliday: isHoliday };
  }

  function tokyoParts(now) {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tokyo', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(now);
    var g = function (t) { return Number(parts.filter(function (x) { return x.type === t; })[0].value); };
    return { date: utc(g('year'), g('month'), g('day')), minutes: (g('hour') % 24) * 60 + g('minute') };
  }

  function nextShipDate(cal, now, cutoffHour) {
    var t = tokyoParts(now), d = t.date;
    if (!(cal.isBusinessDay(d) && t.minutes < cutoffHour * 60)) { do { d = addDays(d, 1); } while (!cal.isBusinessDay(d)); }
    return { shipDate: d, isToday: ymd(d) === ymd(t.date) };
  }

  // 「13時までのご注文で 最短本日9/24発送」／「9/24 13時までのご注文で 最短9/24発送」（曜日なし。9/23夜、1行に収まるよう読点・空白を詰めた）
  function shipLine(cal, now, cutoffHour) {
    var r = nextShipDate(cal, now, cutoffHour);
    var md = (r.shipDate.getUTCMonth() + 1) + '/' + r.shipDate.getUTCDate();
    if (r.isToday) return cutoffHour + '時までのご注文で 最短本日' + md + '発送';
    return md + ' ' + cutoffHour + '時までのご注文で 最短' + md + '発送';
  }

  var PREFIXES = ['denny', 'hz', 'kr', 'mi', 'mini', 'mo', 'on', 'ri', 'rk'];
  var TOGGLES = PREFIXES.map(function (a) { return '[data-' + a + '-message-toggle]'; }).join(',');
  var TRUCK = '<svg class="ka-bd-line__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6.5h10v9H3zM13 9.5h4l3 3.2v2.8h-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="6.5" cy="17" r="1.6" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="17" cy="17" r="1.6" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
  // 「発送目安：ご注文後1～2営業日で発送」（メッセージ入れ希望で1～3）
  function estimateText(withMessage) { return '発送目安：ご注文後' + (withMessage ? '1～3' : '1～2') + '営業日で発送'; }

  function upcomingClosure(cal, now, opt) {
    opt = opt || {}; var minLen = opt.minLength || 4, look = opt.lookahead || 21, fromMin = opt.noticeFromHour === 'sameDay' ? Infinity : (opt.noticeFromHour == null ? 17 : opt.noticeFromHour) * 60;
    var t = tokyoParts(now), date = t.date, runStart = null;
    if (!cal.isBusinessDay(date)) { runStart = date; while (!cal.isBusinessDay(addDays(runStart, -1))) runStart = addDays(runStart, -1); }
    for (var i = 0; i <= look; i++) {
      var cur = addDays(date, i);
      if (!cal.isBusinessDay(cur)) { if (!runStart) runStart = cur; continue; }
      if (runStart) {
        var len = Math.round((cur - runStart) / DAY);
        if (len >= minLen) {
          var daysUntil = Math.round((runStart - date) / DAY);
          // 連休最終日は出さない（翌日から発送＝普段の休日と同じ。9/23夜ユーザー決定）
          if (opt.hideOnLastDay && Math.round((cur - date) / DAY) === 1) return null;
          var show = daysUntil <= 0 || (daysUntil === 1 && t.minutes >= fromMin);
          return show ? { start: runStart, end: addDays(cur, -1), resume: cur, length: len } : null;
        }
        runStart = null;
      }
    }
    return null;
  }

  function noticeText(c) { return fmt(c.start) + '〜' + fmt(c.end) + 'は休業です。' + fmt(c.resume) + 'から順次発送'; }
  // カート用（丁寧な文。1日だけなら単日表記）
  function cartNoticeText(c) { var span = c.length === 1 ? fmt(c.start) : fmt(c.start) + '～' + fmt(c.end); return span + 'は休業です。' + fmt(c.resume) + 'から順次発送させていただきます。'; }

  // 営業日カレンダー：見出し＋凡例＋1か月表示（‹ › で今月〜2か月先まで切替）
  var MONTHS_AHEAD = 2;
  function monthHtml(cal, today, yy, mm) {
    var first = utc(yy, mm, 1), days = new Date(Date.UTC(yy, mm, 0)).getUTCDate(), cells = '';
    for (var b = 0; b < first.getUTCDay(); b++) cells += '<span class="ka-bd-cal__cell ka-bd-cal__cell--empty"></span>';
    for (var d = 1; d <= days; d++) {
      var dt = utc(yy, mm, d), closed = !cal.isBusinessDay(dt), isToday = ymd(dt) === ymd(today);
      cells += '<span class="ka-bd-cal__cell' + (closed ? ' is-closed' : '') + (isToday ? ' is-today' : '') + '"' + (closed ? ' aria-label="' + d + '日 休業"' : '') + '>' + d + '</span>';
    }
    return '<div class="ka-bd-cal__grid">' + DOW.map(function (w, i) { return '<span class="ka-bd-cal__dow' + (i === 0 ? ' is-sun' : i === 6 ? ' is-sat' : '') + '">' + w + '</span>'; }).join('') + cells + '</div>';
  }
  function calendarHtml(cal, now, offset) {
    var today = tokyoParts(now).date, y = today.getUTCFullYear(), m = today.getUTCMonth() + 1;
    offset = Math.max(0, Math.min(MONTHS_AHEAD, offset || 0));
    var yy = y + Math.floor((m - 1 + offset) / 12), mm = ((m - 1 + offset) % 12) + 1;
    return '<div class="ka-bd-cal__head"><strong class="ka-bd-cal__heading">営業日カレンダー</strong><span class="ka-bd-cal__legend"><i class="ka-bd-cal__swatch ka-bd-cal__swatch--closed"></i>休業日<i class="ka-bd-cal__swatch ka-bd-cal__swatch--today"></i>本日</span></div>' +
      '<div class="ka-bd-cal__nav"><button type="button" class="ka-bd-cal__btn" data-ka-bd-prev aria-label="前の月"' + (offset === 0 ? ' disabled' : '') + '>‹</button><span class="ka-bd-cal__title">' + yy + '年' + mm + '月</span><button type="button" class="ka-bd-cal__btn" data-ka-bd-next aria-label="次の月"' + (offset === MONTHS_AHEAD ? ' disabled' : '') + '>›</button></div>' +
      monthHtml(cal, today, yy, mm);
  }
  function mountCalendar(el, cal, now) {
    var offset = 0;
    var draw = function () { el.innerHTML = calendarHtml(cal, now, offset); };
    el.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-ka-bd-prev],[data-ka-bd-next]') : null; if (!t) return;
      offset = Math.max(0, Math.min(MONTHS_AHEAD, offset + (t.hasAttribute('data-ka-bd-next') ? 1 : -1))); draw();
    });
    draw();
  }

  // 帯はPC用（上部お知らせ欄の中）とスマホ用（LINE帯の上）の2か所にある。隣の部品が非表示の幅では、その帯も出さない（二重表示の防止）
  function syncNoticeVisibility(doc) {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-ka-bd-notice]'), function (el) {
      var ref = el.nextElementSibling; // PC: utility-bar__wrapper／スマホ: aside.ss-notice
      if (ref) ref.classList.remove('ka-bd-covered'); // いったん戻して、隣の部品がその幅で表示されるかを調べる
      var hostHidden = ref ? getComputedStyle(ref).display === 'none' || !ref.offsetParent : false;
      el.style.display = hostHidden ? 'none' : '';
      // PC：休業の帯が出ている間は、いつものお知らせ（切替の帯）を隠して1本にする（9/23夜、2本並ぶと重なって見えるため）
      if (ref && !el.hidden && !hostHidden && ref.classList.contains('utility-bar__wrapper')) ref.classList.add('ka-bd-covered');
    });
  }
  function readConfig(doc) {
    var el = doc.getElementById('ka-business-days-config'); if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // 画面への反映。設定が読めない場合は何もしない（既存の表示のまま）。
  function render(doc, now) {
    var cfg = readConfig(doc); if (!cfg) return;
    var cal = makeCalendar(cfg), cutoff = cfg.cutoffHour || 13;
    now = now || new Date();
    // 商品ページ：「カートに入れる」の上に発送目安と急ぎの注記（9/24ユーザー決定：通常の目安を主、当日発送はサブ）
    //   メッセージ入れ「希望する」で 1～3営業日、それ以外は 1～2営業日。元の「発送目安」枠は隠す
    var dispatch = doc.querySelectorAll(PREFIXES.map(function (a) { return '[data-' + a + '-dispatch]'; }).join(','));
    Array.prototype.forEach.call(dispatch, function (el) {
      var form = el.closest('form, product-form, .product-form') || doc;
      var addHost = (form.querySelector('.product-form__add') || doc.querySelector('.product-form__add'));
      if (!addHost) return; // ボタンが見つからない場合は元の表示のまま
      var toggle = form.querySelector(TOGGLES) || doc.querySelector(TOGGLES);
      var top = addHost.parentNode.querySelector('.ka-bd-line');
      if (!top) { top = doc.createElement('p'); top.className = 'ka-bd-line'; addHost.parentNode.insertBefore(top, addHost); }
      var notes = addHost.parentNode.querySelector('.ka-bd-notes');
      if (!notes) { notes = doc.createElement('div'); notes.className = 'ka-bd-notes'; addHost.parentNode.insertBefore(notes, addHost); }
      notes.innerHTML = '<span class="ka-bd-note"><span class="ka-bd-nowrap">お急ぎの方は、<a class="ka-bd-note__link" href="/pages/order-guide#business-days">営業日</a>' + cutoff + '時までの注文で</span><span class="ka-bd-nowrap">当日発送可</span></span>'; // 9/24 ユーザー決定の文言（「営業日」は営業日カレンダーへ）
      var draw = function () {
        var html = TRUCK + '<span>' + estimateText(!!(toggle && toggle.checked)) + '</span>';
        if (top.innerHTML !== html) top.innerHTML = html;
      };
      draw();
      el.parentNode.classList.add('ka-bd-moved'); // 元の行は隠す
      if (el.parentNode.parentNode) el.parentNode.parentNode.classList.add('ka-bd-box'); // 他に見える行がなければ枠ごと隠す（CSS）
      if (!doc.documentElement.dataset.kaBdEstimate) {
        doc.documentElement.dataset.kaBdEstimate = '1';
        // 選択欄→チェック欄の反映を待ってから描き直す
        doc.addEventListener('change', function () { setTimeout(function () { render(doc); }, 0); }, true);
      }
    });
    // カート：<div data-ka-bd-cart hidden></div> 4日以上の連休中（当日0時から）だけ表示
    var cc = upcomingClosure(cal, now, { noticeFromHour: 'sameDay' });
    Array.prototype.forEach.call(doc.querySelectorAll('[data-ka-bd-cart]'), function (el) {
      if (cc) { el.textContent = cartNoticeText(cc); el.hidden = false; } else { el.hidden = true; }
    });
    // 連休の帯：<div data-ka-bd-notice hidden></div>（PC用・スマホ用に1つずつ置ける）
    var c = upcomingClosure(cal, now, { noticeFromHour: cfg.noticeFromHour, hideOnLastDay: true });
    Array.prototype.forEach.call(doc.querySelectorAll('[data-ka-bd-notice]'), function (el) {
      if (c) { el.textContent = noticeText(c); el.hidden = false; } else { el.hidden = true; }
    });
    syncNoticeVisibility(doc);
    // 営業日カレンダー：<div data-ka-bd-calendar></div>
    Array.prototype.forEach.call(doc.querySelectorAll('[data-ka-bd-calendar]'), function (el) {
      if (!el.dataset.kaBdMounted) { el.dataset.kaBdMounted = '1'; mountCalendar(el, cal, now); }
    });
  }

  // 祝日表（年別のJSON）を読み込んでから表示。読めない場合は表示を変えない。
  function boot() {
    var cfg = readConfig(document); if (!cfg) return;
    if (cfg.holidays) return render(document);
    if (!cfg.holidaysUrl) return;
    fetch(cfg.holidaysUrl, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var list = []; Object.keys(j).forEach(function (k) { if (/^\d{4}$/.test(k)) list = list.concat(j[k]); });
      cfg.holidays = list; document.getElementById('ka-business-days-config').textContent = JSON.stringify(cfg);
      render(document);
    }).catch(function () {});
  }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    window.addEventListener('resize', function () { syncNoticeVisibility(document); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) render(document); });
  }
  return { estimateText: estimateText, syncNoticeVisibility: syncNoticeVisibility, cartNoticeText: cartNoticeText, makeCalendar: makeCalendar, tokyoParts: tokyoParts, nextShipDate: nextShipDate, shipLine: shipLine, upcomingClosure: upcomingClosure, noticeText: noticeText, calendarHtml: calendarHtml, render: render, ymd: ymd, parseYmd: parseYmd, fmt: fmt };
});
